import request from "./axios";
import storage from "./storage.js";

function saveBlobAsFile(blob, fileName) {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = blobUrl;
  if (fileName) {
    link.download = fileName;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}

async function resolveDownloadError(blob) {
  if (!blob || !blob.type || !blob.type.includes("application/json")) {
    throw new Error("下载失败");
  }

  const text = await blob.text();
  let data = {};

  try {
    data = text ? JSON.parse(text) : {};
  } catch (error) {
    throw new Error("下载失败");
  }

  request.checkCode({ data });
  throw new Error(data.msg || data.message || "下载失败");
}

export async function downloadByPost(url, payload, fileName) {
  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
    clientId: request.clientId,
  };
  const token = storage.get("_stoken");

  if (token) {
    headers.Authorization = `Bearer ${token.access_token}`;
  }

  const response = await fetch(`${request.baseURL}${url}`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload || {}),
  });
  const blob = await response.blob();

  if (!response.ok) {
    await resolveDownloadError(blob);
  }

  if (blob.type && blob.type.includes("application/json")) {
    await resolveDownloadError(blob);
  }

  saveBlobAsFile(blob, fileName);
}

export function forceDownloadByUrl(url, fileName) {
  return new Promise((resolve, reject) => {
    if (!url) {
      reject(new Error("下载地址为空"));
      return;
    }

    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";

    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(new Error("下载失败"));
        return;
      }

      const blob = xhr.response;
      saveBlobAsFile(blob, fileName);
      resolve();
    };

    xhr.onerror = () => {
      reject(new Error("下载失败"));
    };

    xhr.send();
  });
}
